import script from "./PlanHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanHistory.vue?vue&type=script&setup=true&lang=js"

import "./PlanHistory.vue?vue&type=style&index=0&id=8f0e3bf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f0e3bf8"]])

export default __exports__